module.exports = __webpack_public_path__ + "img/third.7b4b6391.jpg";